module.exports = __webpack_public_path__ + "img/customize.b51fba95.gif";